function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _setInterval from "@babel/runtime-corejs3/core-js/set-interval";
import { defaultClient as defaultConversationsClient } from "@xo-union/sdk-conversations";
import { LOG_OUT_START, FETCH_SUCCESS as MEMBERSHIP_FETCH_SUCCESS, LOG_IN_SUCCESS, SIGN_UP_SUCCESS, getMemberId } from "@xo-union/store-membership-redux";

// Constants
var ONE_MINUTE = 60000;

// Action Types
export var POLL_INIT = '@xo-union/store-conversations/POLL_INIT';
export var FETCH_SUCCESS = '@xo-union/store-conversations/FETCH_SUCCESS';
export var CLEAR = '@xo-union/store-conversations/CLEAR';

// Action Creators
var fetchSuccess = function fetchSuccess(response) {
  return {
    type: FETCH_SUCCESS,
    payload: response
  };
};
var clearPoll = function clearPoll() {
  return {
    type: CLEAR
  };
};
var initPoll = function initPoll(intervalId) {
  return {
    type: POLL_INIT,
    payload: {
      intervalId: intervalId
    }
  };
};

// Thunks
export var fetchConversations = function fetchConversations() {
  return function (dispatch, getState) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$conversationsCli = _ref.conversationsClient,
      conversationsClient = _ref$conversationsCli === void 0 ? defaultConversationsClient : _ref$conversationsCli;
    var params = {
      memberId: getMemberId(getState())
    };
    conversationsClient.getInboxUnreadMessagesCount(params).then(function (response) {
      return dispatch(fetchSuccess(response));
    });
  };
};
export var initConversationsPolling = function initConversationsPolling() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$interval = _ref2.interval,
    interval = _ref2$interval === void 0 ? ONE_MINUTE : _ref2$interval,
    _ref2$fetch = _ref2.fetch,
    fetch = _ref2$fetch === void 0 ? fetchConversations : _ref2$fetch;
  return function (dispatch) {
    var intervalId = _setInterval(function () {
      dispatch(fetch());
    }, interval);
    dispatch(initPoll(intervalId));
  };
};
export var clearConversationsPolling = function clearConversationsPolling() {
  return function (dispatch, getState) {
    var intervalId = getState().conversations.intervalId;
    clearInterval(intervalId);
    dispatch(clearPoll());
  };
};

// Reducer Initial State
var initialState = {
  count: 0,
  intervalId: null
};

// Reducer
var conversationsReducer = function conversationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case FETCH_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        count: action.payload.body.count
      });
    case POLL_INIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        intervalId: action.payload.intervalId
      });
    case CLEAR:
      return initialState;
    default:
      return state;
  }
};

// Middleware
export var conversationsMiddleware = function conversationsMiddleware() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$clear = _ref3.clear,
    clear = _ref3$clear === void 0 ? clearConversationsPolling : _ref3$clear,
    _ref3$init = _ref3.init,
    init = _ref3$init === void 0 ? initConversationsPolling : _ref3$init,
    _ref3$fetch = _ref3.fetch,
    fetch = _ref3$fetch === void 0 ? fetchConversations : _ref3$fetch;
  return function () {
    return function (next) {
      return function (action) {
        var actionResult = next(action);

        /* eslint-disable default-case */
        switch (action.type) {
          case LOG_OUT_START:
            next(clear());
            break;
          case MEMBERSHIP_FETCH_SUCCESS:
          case LOG_IN_SUCCESS:
          case SIGN_UP_SUCCESS:
            next(fetch());
            next(init());
            break;
        }
        return actionResult;
      };
    };
  };
};
export var selectConversationsCount = function selectConversationsCount(state) {
  return state.conversations.count;
};
export default conversationsReducer;